var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"perk-item"},[_c('div',{staticClass:"perk-icon"},[_c('img',{attrs:{"src":_vm.icons[_vm.icon],"alt":_vm.title}})]),_c('div',{staticClass:"headline-5 fbold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"body-md"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }